export const AddDocumentSources = {
	photo: "photo",
	gallery: "gallery",
	file: "file",
} as const;

export type AddDocumentSource =
	(typeof AddDocumentSources)[keyof typeof AddDocumentSources];
